import React from 'react'
import Header from '../inc/Header'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import Solarsystem from "../images/Solar System.jpg";
import Solarwork from "../images/Solar work.jpg";
import Solar from "../images/Solar.jpg";
import Solarsetup from "../images/Solar set.jpg";
import Solarlivework from "../images/SOLAR Live Work.jpg";
import Solarsystemourwork from "../images/Solar System House Care.jpg";
import Solarroof from "../images/Solar Roof.jpg";
import Solarlivework2 from "../images/Solar 2.jpg"
import Solarlivework3 from "../images/Solar 3.jpg";
import Solarlivework4  from "../images/Solar 4.jpg";
import Solarset from "../images/Solar 1.jpg";
import Solarlivework5  from "../images/Solar 5.jpg";
import Solarlivework6 from "../images/Solar 6.jpg";
import Solarlivework7 from "../images/Solar 7.jpg"
import  Solarlivework8 from "../images/Solar 8.jpg";
import Solarlivework9 from "../images/Solar 9.jpg";
import Solarlivework10 from "../images/Solar 10.jpg";
import Solarlivework11 from "../images/Solar 11.jpg";
import Solarlivework12 from "../images/Solar 112.jpg";



function Soller() {
    return (
        <div>
            <Header />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="maroon" />
            <div className='exteriordesign'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Solar</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>



            <div className="album py-2">

                <div className="container ">
                    <div className="row ">
                        <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarsystem} className="card-img-top" alt="Solarsystem" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>
                         <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarwork} className="card-img-top" alt="Solarsystem" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>
                         <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solar} className="card-img-top" alt="Solarsystem" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarsetup} className="card-img-top" alt="Solarsystem" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>

                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarsystemourwork} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>

                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarroof} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>

                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework2} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>

                         <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework3} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>

                         <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework4} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>

                         <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarset} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>


                         <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework5} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>


                         <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework6} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>


                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework7} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>


                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework8} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>

                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework9} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>

                        
                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework10} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>

                        
                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework11} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>

                        
                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={Solarlivework12} className="card-img-top" alt="Solarlivework" />
                                <div className="card-body">
                                    <h5 className="card-title">Solar System</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <br />

        </div>
    )
}

export default Soller